import * as React from 'react'
import './global.css'
import SchoolSongPlayer from './src/components/SchoolSongPlayer'
import { ChakraProvider } from '@chakra-ui/react'
import { ChakraTheme } from './src/theme/theme'

// Mounted once for the whole app: inside the per-page Layout it was torn down and rebuilt
// (theme, global styles, CSS reset) on every navigation
export const wrapRootElement = ({ element }) => <ChakraProvider theme={ChakraTheme}>{element}</ChakraProvider>

// Rendered outside the page so the song keeps playing across page navigations
export const wrapPageElement = ({ element }) => (
    <>
        {element}
        <SchoolSongPlayer />
    </>
)

// Navigation feedback: a top progress bar plus a spinner on the tapped menu item, from the click until
// the new page is rendered (Gatsby's own route hooks only fire once the next page is already loaded)
let pendingLink = null
let pendingTimeout = null

const stopNavigationFeedback = () => {
    document.documentElement.classList.remove('is-navigating')
    pendingLink?.classList.remove('nav-pending')
    pendingLink = null
    clearTimeout(pendingTimeout)
}

export const onClientEntry = () => {
    document.addEventListener(
        'click',
        (e) => {
            if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
            const link = e.target.closest?.('a[href]')
            if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return
            const url = new URL(link.href, window.location.href)
            if (url.origin !== window.location.origin) return
            if (url.pathname === window.location.pathname && url.search === window.location.search) return

            stopNavigationFeedback()
            pendingLink = link
            link.classList.add('nav-pending')
            document.documentElement.classList.add('is-navigating')
            // Never leave it spinning if the navigation fails or is cancelled
            pendingTimeout = setTimeout(stopNavigationFeedback, 15000)
        },
        true
    )
}

export const onRouteUpdate = stopNavigationFeedback
